export const FirebaseConfig = {
	"projectId": "ambulance-chap-chap",
	"appId": "1:770520801792:web:eecb93706a057d4dc5aee5",
	"databaseURL": "https://ambulance-chap-chap-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "ambulance-chap-chap.appspot.com",
	"locationId": "europe-west2",
	"apiKey": "AIzaSyB8fx8giDEz0Hnl_3DvflvxCPx8Q6GaLBg",
	"authDomain": "ambulance-chap-chap.firebaseapp.com",
	"messagingSenderId": "770520801792",
	"measurementId": "G-VMTBHC09VL"
};